/*
 * @Author: 彭梦婷
 * @Date: 2026-06-29 16:09:06
 * @LastEditors: 彭梦婷
 * @LastEditTime: 2026-08-19 10:30:18
 * @Description: 
 * @FilePath: \company-web\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/industry',
    name: 'industry',
    component: () => import(/* webpackChunkName: "industry" */ '../views/BackgroundView.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import(/* webpackChunkName: "service" */ '../views/ServiceView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
   {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "about" */ '../views/NewsView.vue')
  },
  {
    path: 'newsDetail',
    name: 'newsDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/NewsDetailView.vue')
  },
  {
    path: '/aboutus',
    redirect: '/about'
  },
  {
    path: '/ua',
    name: 'ua',
    component: () => import('../views/authorize.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: 'gw',//授权页面需要
  base: '',//，官网为空
  routes,
  scrollBehavior () {
    // 每次进入新页面，强制滚动到顶部
    return { x: 0, y: 0 }
  }
})

export default router
